// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"737":"7a3b1961","897":"component---src-pages-home-index-js"}[chunkId] || chunkId) + "-" + {"522":"363cc224b546316a492e","737":"5c910b6374b06daa07e6","897":"c8571ecfe95f7351b895"}[chunkId] + ".js";
};